{
  "colorSwatchPicker": "Campioni di colore",
  "dropzoneLabel": "Zona di rilascio",
  "selectPlaceholder": "Seleziona un elemento",
  "tableResizer": "Ridimensionamento"
}
